module.exports = __webpack_public_path__ + "static/media/feedback.1f27b90f.jpg";